import { svg, logoConfigPropType } from 'constants';

import React from 'react';

import './HeaderLogo.scss';

const HeaderLogo = ({ config }) => {
  const Component = typeof config.href === 'undefined' ? 'span' : 'a';

  return (
    <Component className="nx-global-header-logo" href={config.href}>
      <img
        className="nx-global-header-logo__text-logo"
        src={svg.logo}
        alt="Go back to dashboard"
      />
    </Component>
  );
};

HeaderLogo.propTypes = {
  config: logoConfigPropType,
};

export default HeaderLogo;
